import { el } from "./dom";

export function createDivider(): HTMLElement {
  return el("div", { class: "divider" }, [
    el("div", { class: "divider__line" }),
    el("div", { class: "divider__diamond" }),
    el("div", { class: "divider__line" }),
  ]);
}
